import React from 'react'
// @ts-expect-error SCSS modules are untyped in this project
import * as styles from '../product-scan.module.scss'

export type ScanBoxProps = {
  backgroundColor: string
  textColor: string
  className?: string
  children: React.ReactNode
}

// The "black box" treatment from BR-5593 isn't in the codebase yet (Promo Step hasn't adopted
// it), so this is built fresh here, driven purely by config colors and kept as its own
// presentational component so BR-5593 can import it later instead of duplicating it.
const ScanBox = ({ backgroundColor, textColor, className, children }: ScanBoxProps) => (
  <div
    className={[styles.scanBox, className].filter(Boolean).join(' ')}
    style={{ backgroundColor, color: textColor }}
  >
    {children}
  </div>
)

export default ScanBox
